var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('GeomFilter',{attrs:{"mode":"animationfonciere"}})],1),_c('div',{staticClass:"column"},[_c('AdvancedSearch')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }